import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    price: {
      description:
        'An adjustment fee is applied at the time of your guest’s activation. Then €{extraSeatCost}/month (excl. tax).',
      included: 'Included',
      label: 'Price',
      perMonth: '€{extraSeatCost}/month (excl. tax)',
    },
    seatsLeft: 'Remaining accesses included in your offer',
  },
  fr: {
    price: {
      description:
        'Des frais d’ajustement sont appliqués au moment de l’activation de votre invité·e. Puis {extraSeatCost} € HT / mois.',
      included: 'Inclus',
      label: 'Prix',
      perMonth: '{extraSeatCost} HT € / mois',
    },
    seatsLeft: 'Accès restants inclus dans votre offre',
  },
} as const);

export default locales;
